"use strict";

import loadScript from './load-script';

export function init () {
    let form = $('.js-mollie-cc__form');
    let formError = $('.js-mollie-cc__form-error');
    let submitButton = $('.js-mollie-cc__submit');

    loadScript('https://js.mollie.com/v1/mollie.js').then(() => {

        let mollie = Mollie('pfl_8JPE8WFF2s', { locale: 'de_DE', testmode: _config.mollieTestmode });
        // let cardComponent = mollie.createComponent('card');
        let cardHolder = mollie.createComponent("cardHolder");
        cardHolder.mount(".js-mollie-cc__card-holder");
        let cardHolderError = document.getElementById("card-holder-error");
        cardHolder.addEventListener("change", function (event) {
            if (event.error && event.touched) {
                cardHolderError.textContent = event.error;
            } else {
                cardHolderError.textContent = "";
            }
        });

        let cardNumber = mollie.createComponent("cardNumber");
        cardNumber.mount(".js-mollie-cc__card-number");
        let cardNumberError = document.getElementById("card-number-error");

        cardNumber.addEventListener("change", function (event) {
            if (event.error && event.touched) {
                cardNumberError.textContent = event.error;
            } else {
                cardNumberError.textContent = "";
            }
        });


        let expiryDate = mollie.createComponent("expiryDate");
        expiryDate.mount(".js-mollie-cc__expiry-date");

        let expiryDateError = document.getElementById("expiry-date-error");

        expiryDate.addEventListener("change", function (event) {
            if (event.error && event.touched) {
                expiryDateError.textContent = event.error;
            } else {
                expiryDateError.textContent = "";
            }
        });


        let verificationCode = mollie.createComponent("verificationCode");
        verificationCode.mount(".js-mollie-cc__verification-code");

        let verificationCodeError = document.getElementById(
            "verification-code-error"
        );

        verificationCode.addEventListener("change", function (event) {
            if (event.error && event.touched) {
                verificationCodeError.textContent = event.error;
            } else {
                verificationCodeError.textContent = "";
            }
        });

        let $mollieCollapse = $('.js-mollie-cc__collapse');
        let $triggerMollieCollapse = $('.js-mollie__trigger-cc-collapse');

        $('.js-mollie__close-cc-collapse').on('click', function () {
            $('.js-mollie-cc__collapse').collapse('hide');
        });

        $mollieCollapse.on('hide.bs.collapse', function () {
            form.unbind('submit');
        });

        $mollieCollapse.on('show.bs.collapse', function () {
            form.on('submit', function (event) {
                event.preventDefault();
                disableForm();

                // set the input value to the selected payment method (for validation)
                let $paymentGroup = $(this).closest('.js-payment-group__item');
                let ccInput = $paymentGroup.find('.js-payment-group__input');
                ccInput.prop('checked', true);


                // Reset possible form error
                formError.textContent = "";

                // Get a payment token

                mollie.createToken().then(function (result) {
                    let token = result.token;
                    let error = result.error;

                    if (error) {
                        enableForm();
                        formError.textContent = error.message;
                        return;
                    }

                    // Add token to the form
                    let tokenInput = document.createElement("input");
                    tokenInput.setAttribute("name", "token");
                    tokenInput.setAttribute("type", "hidden");
                    tokenInput.setAttribute("value", token);

                    form[0].appendChild(tokenInput);

                    // Re-add the submit type to the form
                    let submitTypeInput = document.createElement("input");
                    submitTypeInput.setAttribute("name", "submitType");
                    submitTypeInput.setAttribute("type", "hidden");
                    submitTypeInput.setAttribute("value", event.originalEvent.submitter.value);

                    form[0].appendChild(submitTypeInput);

                    // Re-submit form to the server
                    form[0].submit();
                });

            });
        })

        if ($triggerMollieCollapse.length > 0) {
            let collapseTarget = $triggerMollieCollapse.data('target');
            $(collapseTarget).collapse('show');
        }

    }).catch(console.error);


    /**
     * Disables the form inputs and submit button
     */
    function disableForm() {
        submitButton.disabled = true;
    }

    /**
     * Enables the form inputs and submit button
     */
    function enableForm() {
        submitButton.disabled = false;
    }
}

